<template>
  <div class="wrapper">
    <div class="main">
      <img :src="header.image"/>
      <div class="section">
        <!-- Header start -->
        <div class="container" style="margin-top: 3%">
          <div class="md-layout md-alignment-center-center">
            <div class="md-layout-item md-size-35">
              <div class="md-layout">
                <div class="md-layout-item md-size-100">
                  <h2
                    class="title text-heading-pr"
                    style="text-transform: uppercase"
                  >
                    {{ header.title }}
                  </h2>
                </div>
                <div class="md-layout-item md-size-100">
                  <div>{{ header.description }}</div>
                </div>
              </div>
            </div>
            <div class="md-layout-item md-size-25">
              <img
                :src="header.image1"
                style="object-fit: cover; width: 100%"
              />
            </div>
            <div class="md-layout-item md-size-25">
              <img
                :src="header.image2"
                style="object-fit: cover; width: 100%"
              />
            </div>
          </div>
        </div>
        <!-- Header End -->

        <!-- Mission-vision-value (mvv) begins -->
        <div class="section md-layout md-alignment-top-center">
          <div class="md-layout-item md-size-20 md-small-size-100">
            <h2>Mission</h2>
            <hr />
            <p>{{ mission }}</p>
          </div>
          <div class="md-layout-item md-size-20 md-small-size-100">
            <h2>Vision</h2>
            <hr />
            <p>{{ vision }}</p>
          </div>
          <div class="md-layout-item md-size-20 md-small-size-100">
            <h2>Values</h2>
            <hr />
            <p>{{ values }}</p>
          </div>
        </div>

         <!-- Quote Start -->
        <div class="section section-dark">
          <div class="text-center">
            <md-icon class="text-white md-size-3x">format_quote</md-icon>
          </div>

          <div class="md-layout md-alignment-center-center">
            <div
              class="md-layout-item md-size-50 md-small-size-100 text-center text-white"
              v-html="aboutUs"
            ></div>
          </div>
        </div>
        <!-- Quote End -->
        <!-- Mission-vision-value (mvv) ends -->

        <!-- Layout begins -->
<!-- 
        <div
          class="md-layout section section-dark"
          style="margin-left: 0; margin-right: 0; margin-top: 5%"
        > -->
          <!-- Left slide -->
          <!-- <div
            class="md-layout-item md-size-33 md-small-size-100"
            style="height: 50vh; padding: 0"
          >
            <div class="md-layout" style="margin-left: 0; margin-right: 0">
              <div class="md-layout-item md-size-100">
                <h2 class="title text-heading-pr">Our journey</h2>
              </div>
              <div class="md-layout-item md-size-100 text-white">
                <div
                  v-for="(date, index) in importantDates"
                  :key="index"
                  style="margin-bottom: 2%"
                >
                  <b>{{ date.date }}</b> <br />
                  {{ date.description }}
                  <br />
                </div>
              </div>
            </div>
          </div>

          <div class="md-layout-item md-size-33">
            <img :src="sectionImage" style="object-fit: cover; height: 100%" />
          </div>

          <div class="md-layout-item md-size-33">
            <h3 class="title text-heading-pr">{{ graphArea.heading }}</h3>
            <br />
            <div v-for="(graph, index) in graphArea.graphs" :key="index">
              <k-progress
                :percent="graph.percent"
                :color="graph.color"
                :active="true"
                :line-height="3"
              />
              <div class="caption">{{ graph.caption }}</div>
              <br />
            </div>
          </div>
        </div> -->
        <!-- What sets us apart end -->

        <!-- About Us Start -->
        <!-- <div class="section">
          <h2 class="title text-center">How we came into existence</h2>
          <div class="md-layout md-alignment-center-center">
            <div
              class="md-layout-item md-size-50 md-small-size-100 text-center"
              v-html="aboutUs"
            ></div>
          </div>
        </div> -->
        <!-- About Us End -->

        <!-- Artysan in the media -->

        <!-- <splide :options="inTheMedia.options">
          <splide-slide>
            <h1>Hello</h1>
          </splide-slide>
          <splide-slide>
            <h1>There</h1>
          </splide-slide>
        </splide> -->
        <!-- <h2>In the media here</h2> -->
        <h2 class="text-center">In the media</h2>
        <template>
          <el-carousel
            :interval="4000"
            indicator-position="inside"
            type="card"
            height="200px"
          >
            <el-carousel-item
              v-for="coverage in inTheMedia"
              :key="coverage.title"
            >
              <div class="text-center text-white">
                <h3>{{ coverage.title }}</h3>
                <p>{{ coverage.date }}</p>
                <br />
                <h4>
                  <b>{{ coverage.description }}</b>
                </h4>
                <h4>
                  <em>{{ coverage.story }}</em>
                </h4>
                <br/>
                <div v-for="url in coverage.urls" :key="url.link">
                  <h6><a :href="url.link" target="_blank">Read more on {{url.name}}</a></h6>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </template>

        <!-- Team Start -->
        <div class="" :style="sectionTeam()">
          <div class="container">
            <div class="md-layout">
              <div
                class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center"
              >
                <h2 class="title">The Team</h2>
                <br />
              </div>
            </div>
            <div class="md-layout">
              <div
                v-for="(person, index) in team"
                :key="index"
                class="md-layout-item md-size-25 md-small-size-50"
              >
                <profile-card
                  card-avatar
                  :shadow-normal="false"
                  :no-colored-shadow="false"
                  :card-image="person.image"
                >
                  <template slot="cardContent">
                    <h4 class="card-title">{{ person.name }}</h4>
                    <p>
                      <em
                        ><b>{{ person.salutation }}</b></em
                      >
                    </p>
                    <p>{{ person.description }}</p>
                  </template>
                </profile-card>
              </div>
            </div>
          </div>
        </div>
        <!-- Team end -->

       
      </div>
    </div>
  </div>
</template>

<script>
import { Splide, SplideSlide } from "@splidejs/vue-splide";
import { ProfileCard } from "@/components";

export default {
  components: {
    // Splide,
    // SplideSlide
    ProfileCard,
  },
  data() {
    return {
      header: {
        title: "Catering to your all creative needs.",
        description: `We make use of our artistic cells to present you with our wide range of
services, delivering inspiration and expertise with ease. We aim to take
things up a notch and make your vision a reality.`,
        image1: require("@/assets/img/PR/digital pr.jpeg"),
        image2: require("@/assets/img/PR/seo.jpg"),
        image: require("@/assets/img/about-us/header.jpg"),
      },
      mission:
        "We aim to beautify the path we follow, grabbing all opportunities along the way, and going above and beyond to spark souls.",
      vision:
        "We wish to bridge the existent gap between Artists, their gifted Artwork, and other inhabitants of the globe, delivering a medley of magic.",
      values:
        "We strongly believe in originality, and not mere adaptations. We follow an ethical approach towards all our projects, solely focused on bringing your ideas to light.",
      importantDates: [
        {
          date: "20th October 2020",
          description: "Good day for business.",
        },
        {
          date: "23th October 2020",
          description: "Good day for business once more.",
        },
      ],
      sectionImage: require("@/assets/img/PR/digital pr.jpeg"),
      graphArea: {
        heading:
          "We provide high quality and cost effective offshore web services.",
        graphs: [
          {
            percent: 80,
            color: "red",
            caption: "JQUERY - 4 YEARS EXPERIENCE",
          },
          {
            percent: 80,
            color: "yellow",
            caption: "JS - 2 YEARS EXPERIENCE",
          },
        ],
      },
      aboutUs: `<p><i>The fire that drives Artysan’s work - an Invincible Passion</i>
      <br/><br/>
We’re a team of enthusiastic change-makers that aims to satisfy clients to the
best of our abilities. Driven by cross-functional approaches to all our projects, we
display exclusivity while catering to any venture.
<br/>
<br/>
We came into the picture when our Founder accompanied by a team of young,
budding enthusiasts was offered the creative task of doing graffiti work for an
acquaintance. The days spent painting led them to realize how insignificantly
artists were viewed in the world, how they usually failed to receive the attention
they deserved.
<br/>
<br/>
The team correlated with this experience and ventured on to expand their
creative wings into birthing something sensational in the form of a small startup
enterprise called - Artysan. We vowed to help bridge the existent gap between
ingenious artwork, talented artists, and the rest of the citizens all around the
world, one step at a time.
<br/>
<br/>
Initially offering services like designing Wall Art, Graffiti, and Murals, Artysan
also provided Interior Design solutions to help beautify localities, with our
personal touch. As time progressed, we ventured into manufacturing slick Epoxy
Resin furniture and crafting hand-painted women’s ethnic wear under the brand
name of ‘Snehin’.
<br/>
<br/>
Artysan’s latest venture involves the provision of strategic Digital Marketing
solutions to local businesses to help boost their online presence and garner
more sales. This goes under the title of ‘Spotlight Scouts’ - a team of Inbound
Marketers.
<br/>
<br/>
Today, we’ve diversified into a wide array of services, all delivering creative
results and helping promote our artistic talents.
<br/>
<br/>
<i>Indulge in our holistic services, we’re guaranteed to satisfy your demands, diligently
pioneering every step of the way!</i></p>`,
      team: [
        {
          name: "Sanchit Mahajan",
          image: require("@/assets/img/team/sanchit.jpg"),
          salutation: "Founder & Director",
          description: `A passionate soul capable of converting
even the craziest ideas`,
        },
        {
          name: "Pratishtha Budhiraja",
          image: require("@/assets/img/team/pratishtha.jpg"),
          salutation: "Marketing Associate",
          description: `The human equivalent of a gem
who lights up the room with her kindness`,
        },
        {
          name: "Pawan Jangid",
          image: require("@/assets/img/team/pawan.jpg"),
          salutation: "Chief Associate Artist",
          description: `A non-stop chatterbox and a hidden
artistic talent who’s rejuvenated 24x7`,
        },
        {
          name: "Muskan Sahijwani",
          image: require("@/assets/img/team/pawan.jpg"),
          salutation: "Content Strategist",
          description: `The bubbly one with a delightful sense
of humor, keeping the team entertained with her crazy antics`,
        },
      ],
      inTheMedia: [
        {
          title: "Times of India and DU Beat Hindu",
          date: "November 2016",
          description: "Check yourself, before you Wreck yourself",
          story:
            "Team Artysan’s Community Wall Art campaign against Drunk Driving at Ramjas College’s centennial carnival celebrations.",
          urls: [
            {
              name: "DU Beat",
              link:
                "​https://dubeat.com/2016/11/ramjasites-celebrate-as-the-college-hosts-the-grand-centennial-carnival/",
            },
            {
              name: "Times of India",
              link:
                "​https://timesofindia.indiatimes.com/entertainment/events/delhi/Ramjas-centennial-carnival-celebrates-many-causes/articleshow/55204568.cms",
            },
          ],
        },
        {
          title: "Sonu Nigam’s concert",
          date: "January 2017",
          description: "The one where Artysan shot for the Star",
          story:
            "Sanchit Mahajan scores yet another interview regarding his startup venture Artysan and the team’s exhilarating journey.",
          urls: [
            {
              link:
                "​https://www.hindustantimes.com/music/singer-sonu-nigam-charms-ramjas-college-at-their-centennial-finale/story-Fz0o7y0JOafLQ37mDOJkYM.html",
              name: "Hindustan Times",
            },
          ],
        },
        {
          title: "Youthinc",
          date: "August 2017",
          description:
            "The inspiring tale of our creatively inclined organization",
          story:
            "Sanchit Mahajan scores yet another interview regarding his startup venture Artysan and the team’s exhilarating journey.",
          urls: [
            {
              link:
                "https://www.facebook.com/youthinkyouthinc/videos/498290187229912/",
              name: "Facebook",
            },
          ],
        },
        {
          title: "NDTV",
          date: "May 2019",
          description:
            "Exclusive coverage of our ever-bubbling creative juices",
          story:
            "Team Artysan’s Founder, Sanchit Mahajan receives an opportunity to be interviewed about his artistic venture.",
          urls: [
            {
              name: "Instagram",
              link:
                "https://www.instagram.com/p/BzqLbdHAkmi/?igshid=1vmsb2czryztw/",
            },
          ],
        },
        {
          title: "Wepreneurs",
          date: "July 2020",
          description: "Yet another passionate rendition of our story",
          story:
            "Artysan’s journey right from the beginning receives a retelling through Sanchit Mahan’s exclusive interview.",
          urls: [
            {
              name: "Instagram",
              link:
                "​https://www.instagram.com/p/CC5y7TUps5v/?igshid=brl1l1x08f98​/",
            },
          ],
        },
      ],
    };
  },
  methods: {
    sectionTeam(image) {
      return {
        backgroundImage: `url(${image})`,
      };
    },
  },
};
</script>
<style>
.el-carousel__item:nth-child(2n) {
  background-color: #343434;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #3d3939;
}
</style>
